export default "__VITE_PUBLIC_ASSET__df601e22__"